var _circle, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnfrageTranlsater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01217,
    cy: 8.61047,
    r: 7.79688,
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.94971,
    y: 6.14151,
    width: 10.125,
    height: 1.0625,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.94971,
    y: 9.57901,
    width: 10.125,
    height: 1.0625,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2622 3.548L10.2622 13.673L9.19971 13.673L11.1997 3.548L12.2622 3.548Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82471 3.548L6.82471 13.673L5.76221 13.673L7.76221 3.548L8.82471 3.548Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnfrageTranlsater);
export default __webpack_public_path__ + "static/media/anfrage-tranlsater.9383b500220b4837c77be11d9f65e027.svg";
export { ForwardRef as ReactComponent };